import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY, ApproveStatusEnum } from '../constants';
import { apiProvider } from '../api';

const edit = {
	Id: null as number | null,
	TicketId: null as number | null,
	NewTicketId: null as number | null,
	FirstName: null as string | null,
	MiddleName: null as string | null,
	LastName: null as string | null,
	FirstNameStatus: null,
	LastNameStatus: null,
	MiddleNameStatus: null,
	EmailAdresa: null as string | null,
	EmailAdresaStatus: null,
	Gender: null as string | null,
	GenderStatus: null,
	TelMobNr: null as string | null,
	TelMobNrStatus: null,
	RegisteredMobile: null as string | null,
	RegisteredMobileStatus: null,
	RegisteredCityCode: null as string | null,
	RegisteredCityCodeStatus: null,
	RegisteredStateCode: null as string | null,
	RegisteredStateCodeStatus: null,
	RegisteredPinCode: null as number | null,
	RegisteredPinCodeStatus: null,
	RegisteredPhone: null as string | null,
	RegisteredPhoneStatus: null,
	ResidenceMobile: null as string | null,
	ResidenceMobileStatus: null,
	VerifiedResidenceMobile: null as string | null,
	ResidenceCityCode: null as string | null,
	ResidenceCityCodeStatus: null,
	ResidenceStateCode: null as string | null,
	ResidenceStateCodeStatus: null,
	ResidencePinCode: null as number | null,
	ResidencePinCodeStatus: null,
	ResidencePhone: null as string | null,
	ResidencePhoneStatus: null,
	OfficeMobile: null as string | null,
	OfficeMobileStatus: null,
	OfficeCityCode: null as string | null,
	OfficeCityCodeStatus: null,
	OfficeStateCode: null as string | null,
	OfficeStateCodeStatus: null,
	OfficePinCode: null as number | null,
	OfficePinCodeStatus: null,
	OfficePhone: null as string | null,
	OfficePhoneStatus: null,
	VerifiedOfficePhone: null as string | null,
	TelecallerText: null as string | null,
	PartnerTypPzn: null as number | null,
	PartnertypPznText: null as string | null,
	VerificationAction: null as number | null,
	CallStatus: null as number | null,
	PartnerType: null as string | null,
	PartnerTypeStatus: null,
	RescheduleDate: null as Date | null,
	UpdatedCustomerData: {
		VerifiedFirstName: null as string | null,
		VerifiedMiddleName: null as string | null,
		VerifiedLastName: null as string | null,
		VerifiedEmailAdresa: null as string | null,
		VerifiedTelMobNr: null as string | null,
		VerifiedRegisteredMobile: null as string | null,
		VerifiedRegisteredPinCode: null as number | null,
		VerifiedRegisteredPhone: null as string | null,
		VerifiedResidencePinCode: null as number | null,
		VerifiedResidencePhone: null as string | null,
		VerifiedOfficeMobile: null as string | null,
		VerifiedOfficePinCode: null as number | null,
		VerifiedRegisteredStateCode: null as number | null,
		VerifiedGender: null as number | null,
		VerifiedResidenceStateCode: null as number | null,
		VerifiedOfficeStateCode: null as number | null,
		VerifiedRegisteredCityCode: null as number | null,
		VerifiedResidenceCityCode: null as number | null,
		VerifiedOfficeCityCode: null as number | null,
	},
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		PartnerTypPzn: [],
		VerifiedResidenceStateCode: [],
		VerifiedRegisteredStateCode: [],
		VerifiedOfficeStateCode: [],
		VerificationAction: [],
		CallStatus: [],
		VerifiedRegisteredCityCode: [],
		VerifiedResidenceCityCode: [],
		VerifiedOfficeCityCode: [],
		VerifiedGender: [],
		GenderStatus: [],
		PartnerTypeStatus: [],
		FirstNameStatus: [],
		MiddleNameStatus: [],
		LastNameStatus: [],
		EmailAdresaStatus: [],
		TelMobNrStatus: [],
		RegisteredMobileStatus: [],
		RegisteredStateCodeStatus: [],
		RegisteredCityCodeStatus: [],
		RegisteredPinCodeStatus: [],
		RegisteredPhoneStatus: [],
		ResidenceMobileStatus: [],
		ResidenceStateCodeStatus: [],
		ResidenceCityCodeStatus: [],
		ResidencePinCodeStatus: [],
		ResidencePhoneStatus: [],
		OfficeMobileStatus: [],
		OfficeStateCodeStatus: [],
		OfficeCityCodeStatus: [],
		OfficePinCodeStatus: [],
		OfficePhoneStatus: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
